import {Component, OnInit} from "@angular/core";
import {BillingService} from "../billing/services/billing.service";

@Component({
    selector: 'upgrade-plan',
    templateUrl: './upgrade-plan.component.html',
})
export class UpgradePlanComponent implements OnInit {
    constructor(
        private billingService: BillingService
    ) {

    }
    ngOnInit(): void {
        this.billingService.requestPortalUrl().then(r => {
            window.location.href = r.value;
        });
    }

}